module.exports = __webpack_public_path__ + "img/CPTemp14.f7f4ad3d.png";